import { ToggleGroup as ToggleGroupPrimitive } from 'radix-ui';
import type { ComponentProps } from 'react';
import { cn } from '../../lib/cn.ts';

/** A segmented control: one choice out of a few, with arrow-key navigation. */
export function SegmentedControl({
  className,
  ...props
}: Omit<Extract<ComponentProps<typeof ToggleGroupPrimitive.Root>, { type: 'single' }>, 'type'>) {
  return (
    <ToggleGroupPrimitive.Root
      type="single"
      className={cn(
        'inline-flex flex-wrap rounded-md border border-input bg-card p-0.5',
        className,
      )}
      {...props}
    />
  );
}

export function SegmentedItem({
  className,
  ...props
}: ComponentProps<typeof ToggleGroupPrimitive.Item>) {
  return (
    <ToggleGroupPrimitive.Item
      className={cn(
        'rounded-sm px-3 py-1.5 text-sm font-medium text-foreground transition-colors hover:bg-muted',
        'data-[state=on]:bg-primary data-[state=on]:text-primary-foreground',
        className,
      )}
      {...props}
    />
  );
}
